export const SESSION_MAX_AGE = 12 * 60 * 60
// export const SESSION_MAX_AGE = 1 * 60 * 60
